module.exports = __webpack_public_path__ + "img/hr-brown-fluff-10.40dff62a.png";